var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 145,
    viewBox: "0 0 706 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 706,
    height: 145,
    rx: 12.2079,
    fill: "#84C70D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_504_9272",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 706,
    height: 145
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 706,
    height: 145,
    rx: 12.2079,
    fill: "#84C70D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_504_9272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-51.4946 206.5C-173.495 218.1 -131.995 116.334 -95.9946 64.0002V-84H672.006C644.173 -29.3333 548.806 84.6002 390.006 103C191.506 126 186.006 29.5002 140.006 31.0002C94.0059 32.5002 101.005 192 -51.4946 206.5Z",
    fill: "#73AB10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.1 30.7177C1102.24 21.6021 1069.2 101.573 1040.53 142.698V259H429C451.163 216.042 527.1 126.51 653.547 112.051C811.607 93.9766 815.986 169.809 852.614 168.63C889.243 167.451 883.669 42.1122 1005.1 30.7177Z",
    fill: "#73AB10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardBg);
export default __webpack_public_path__ + "static/media/leaderboard-bg.441435a6494be041a834402bbe2396b6.svg";
export { ForwardRef as ReactComponent };